import { useSyncExternalStore } from 'react';

const MOBILE_QUERY = '(max-width: 599.95px)';
const TABLET_QUERY = '(min-width: 600px) and (max-width: 899.95px)';
const DESKTOP_QUERY = '(min-width: 900px)';
const BELOW_TABLET_QUERY = '(max-width: 899.95px)';

const getMediaQueryList = (query: string) =>
  typeof window === 'undefined' || typeof window.matchMedia !== 'function'
    ? undefined
    : window.matchMedia(query);

const useBrowserMediaQuery = (query: string) =>
  useSyncExternalStore(
    onStoreChange => {
      const mediaQueryList = getMediaQueryList(query);
      if (!mediaQueryList) return () => undefined;

      mediaQueryList.addEventListener('change', onStoreChange);
      return () => mediaQueryList.removeEventListener('change', onStoreChange);
    },
    () => getMediaQueryList(query)?.matches ?? false,
    () => false
  );

export const useBreakpoints = () => {
  const isMobile = useBrowserMediaQuery(MOBILE_QUERY);
  const isTablet = useBrowserMediaQuery(TABLET_QUERY);
  const isDesktop = useBrowserMediaQuery(DESKTOP_QUERY);
  const belowTablet = useBrowserMediaQuery(BELOW_TABLET_QUERY);

  return {
    isMobile,
    isTablet,
    isDesktop,
    belowTablet
  };
};
